import { put, call, takeEvery } from 'redux-saga/effects';
import * as actions from './actions';
import { Endpoints } from './../../services/api/index';
import errorHandler from './../../common/errorHandler';
const headers = {
  'x-api-key': process.env.REACT_APP_API_KEY,
};

function* getHostedPage(api, payload) {
  let result = yield call(
    [api, api.post],
    `${Endpoints.customerManagement}/api/v2/customers/subscriptions/hostedpage`,
    payload,
    headers
  );
  return result.data;
}

export function* getHostedPageRequest(api, payload) {
  try {
    const data = yield call(getHostedPage, api, payload);
    yield put(actions.getHostedPageSuccess(data));
  } catch (error) {
    let errObj = errorHandler(error);
    yield put(actions.getHostedPageFailure(errObj));
  }
}

export function* watchGetHostedPageRequest(api, { params }) {
  yield call(getHostedPageRequest, api, params);
}

function* getCredentialFromHostedPage(api, { payload }) {
  // Dummy Credential for testing purposes
  return {
    credential: {
      id: 'clientId:12789789273132',
      secret: 'secret:xxxx123kskdfjoinsdoisknso',
    },
  };
  let result = yield call(
    [api, api.get],
    `${Endpoints.customerManagement}/api/v2/customers/credentials/${payload}`,
    headers
  );
  return result.data;
}

export function* getCredentialFromHostedPageRequest(api, params) {
  try {
    const data = yield call(getCredentialFromHostedPage, api, params);
    yield put(actions.getCredentialFromHostedPageSuccess(data));
  } catch (error) {
    let errObj = errorHandler(error);
    yield put(actions.getCredentialFromHostedPageFailure(errObj));
  }
}

export function* watchGetCredentialFromHostedPageRequest(api, params) {
  yield call(getCredentialFromHostedPageRequest, api, params);
}

const helper = function* ({ api }) {
  yield takeEvery(actions.GET_HOSTED_PAGE_REQUEST, watchGetHostedPageRequest, api);
  yield takeEvery(actions.GET_CREDENTIAL_FROM_HOSTED_PAGE_REQUEST, watchGetCredentialFromHostedPageRequest, api);
};

export default helper;
